import React from 'react';
import { Typography, colors, TypographyProps } from '@mui/material';

export const HintText = (props: TypographyProps) => (
  <Typography {...props} style={{ ...(props.style || {}), color: colors.grey['400'] }} />
)
